import { validateDriverForm } from "../driverDetails/validators";
import { INVALID_ROUTE_NUMBER } from "../../constants/strings";

export const validateAddRoute = (values) => {
  const { driverCode } = values;

  if (driverCode) {
    return validateDriverForm(values);
  }

  return {};
};

export const validateRouteNumber = (routeNumber) => {
  if (!routeNumber || routeNumber.length !== 3 || !/[0-9]/g.test(routeNumber)) {
    return INVALID_ROUTE_NUMBER;
  }
};
